export default "__VITE_ASSET__CdjjKRuX__"